import React from "react";
import { Grid, Modal, ModalBody } from "react-bootstrap";
import id from "@irati/utils/id";
import Close from "../Close";
import "./FullModal.css";
var FullModal = function (props) {
    var idNamespace = id("full-modal", props);
    var className = props.className, show = props.show, onEnter = props.onEnter, onHide = props.onHide, onScroll = props.onScroll;
    return (React.createElement(Modal, { id: idNamespace, bsSize: "lg", show: show, onHide: onHide, onEnter: onEnter, className: "full-modal " + className, onScroll: onScroll },
        React.createElement(ModalBody, null,
            React.createElement(Grid, null,
                React.createElement(Close, { id: id("btn-close", idNamespace), top: "20px", right: "30px", onClick: onHide }),
                props.children))));
};
FullModal.defaultProps = {
    className: "",
    onEnter: function () { },
    onScroll: function () { }
};
export default FullModal;
